import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import BadgeUI from '../../../widgets/output/BadgeUI'
import ButtonTinyUI from '../../../widgets/action/ButtonTinyUI.js'
import PFStatusUpdateModalSF from './PFStatusUpdateModalSF.js'
import PF2StatusUpdateModalSF from './PF2StatusUpdateModalSF.js'
import ProcessingFeeModalSF from './ProcessingFeeModalSF.js'
import { Link } from 'react-router-dom'
import FileUploadModalSF from '../../../widgets/form/FileUploadModalSF'
import ProcFeeConfirmationModalSF from './ProcFeeConfirmationModalSF.js'

const ProcessingFeeUI = ({ loan, context, onRefreshClick,
  pFStatusUpdated, onPFStatusUpdateClick, onPFStatusCancelClick,
  pF2StatusUpdated, onPF2StatusUpdateClick, onPF2StatusCancelClick,
  onProcFeeClick, selectedPart, feeAmount,
  processingFeeMode, onProcessingFeeClick, onProcessingFeeCancel,
  uploadTDSMode1, onUploadTDSCancelClick, onUploadTDSUpload1, uploadTDSMode2, onUploadTDSUpload2,
  onUploadTDSClick1, onUploadTDSClick2, onDownloadClick1, onDownloadClick2,
  onProcFeeCancel, procFeeMode
}) =>
  <CardUI className='g_m_bottom_100' title='Loan processing fee (upfront fee)'>
    <div>
      <Link onClick={onProcessingFeeClick} to='#'>
        Processing Fee from Loan
      </Link>
      <br />
      <span>{loan.termSheet.processingFeePercentF} of loan amount + 18% GST</span>
    </div>

    {
      loan.termSheet.processingFee1.amountWithoutTax > 0 &&
      <ProcFees context={context} loan={loan} fee={loan.termSheet.processingFee1} status={loan.procFee1Status}
        processingFeeFromLoan={loan.termSheet.processingFeeFromLoan}
        tdsF1={loan.procFee1TdsF1} onUpdateClick={onPFStatusUpdateClick}
        onProcFeeClick={onProcFeeClick} feeAmount={feeAmount}
        part='1' selectedPart={selectedPart} onUploadTDSClick={onUploadTDSClick1} onDownloadClick={onDownloadClick1}
        tdsChallanUploaded={loan.tdsChallan1Uploaded} onProcFeeCancel={onProcFeeCancel}
        procFeeMode={procFeeMode} onRefreshClick={onRefreshClick}
      />
    }

    <ProcFees context={context} loan={loan} fee={loan.termSheet.processingFee2} status={loan.procFee2Status}
      processingFeeFromLoan={loan.termSheet.processingFeeFromLoan}
      tdsF1={loan.procFee2TdsF1} onUpdateClick={onPF2StatusUpdateClick}
      onProcFeeClick={onProcFeeClick} feeAmount={feeAmount}
      part='2' selectedPart={selectedPart} onUploadTDSClick={onUploadTDSClick2} onDownloadClick={onDownloadClick2}
      tdsChallanUploaded={loan.tdsChallan2Uploaded} onProcFeeCancel={onProcFeeCancel}
      procFeeMode={procFeeMode} onRefreshClick={onRefreshClick}
    />

    <PFStatusUpdateModalSF context={context} loan={loan} part='1' onRefreshClick={onRefreshClick}
      onCancelClick={onPFStatusCancelClick} updateMode={pFStatusUpdated} />
    <PF2StatusUpdateModalSF context={context} loan={loan} part='2' onRefreshClick={onRefreshClick}
      onCancelClick={onPF2StatusCancelClick} updateMode={pF2StatusUpdated} />

    <ProcessingFeeModalSF context={context} loan={loan} onRefreshClick={onRefreshClick}
      onCancelClick={onProcessingFeeCancel} updateMode={processingFeeMode}
    />

    <FileUploadModalSF context={context} titleLabel='Upload TDS Challan 1' uploadMode={uploadTDSMode1}
      onCancelClick={onUploadTDSCancelClick} signedUrlApi={`/api/su/loans/${loan.loanId}/processingFees/1/tds/challan/fileUploadSignedUrl`}
      onUpload={onUploadTDSUpload1}
    />
    <FileUploadModalSF context={context} titleLabel='Upload TDS Challan 2' uploadMode={uploadTDSMode2}
      onCancelClick={onUploadTDSCancelClick} signedUrlApi={`/api/su/loans/${loan.loanId}/processingFees/2/tds/challan/fileUploadSignedUrl`}
      onUpload={onUploadTDSUpload2}
    />

  </CardUI>

const ProcFees = ({ context, loan, fee, status, tdsF1, onUpdateClick,
  onProcFeeClick, part, selectedPart, feeAmount, onUploadTDSClick, onDownloadClick,
  tdsChallanUploaded, onProcFeeCancel, procFeeMode, onRefreshClick
}) =>
  <CardUI title={`Processing Fee ${part}`} className='g_m_top_100'>
    <div className='g_flex_h '>
      <div className='g_flex_v'>
        <div>
          {
            fee.amountWithoutTax !== 0 &&
            <table>
              <tbody>
                <tr>
                  <td>Fee:</td>
                  <td className='g_text_right'>{fee.amountWithoutTaxF1}</td>
                </tr>
                {
                  fee.igstF2 &&
                  <tr>
                    <td>{fee.igstLabel}:</td>
                    <td className='g_text_right'>{fee.igstF1}</td>
                  </tr>
                }
                {
                  fee.cgstF2 &&
                  <tr>
                    <td>{fee.cgstLabel}:</td>
                    <td className='g_text_right'>{fee.cgstF1}</td>
                  </tr>
                }
                {
                  fee.sgstF2 &&
                  <tr>
                    <td>{fee.sgstLabel}:</td>
                    <td className='g_text_right'>{fee.sgstF1}</td>
                  </tr>
                }
                <tr>
                  <td>Total:</td>
                  <td className='g_text_right'>{fee.amountWithTaxF1}</td>
                </tr>
              </tbody>
            </table>
          }
        </div>

        {
          fee.initiateDateF1 && (
            <div>Initiated Date: {fee.initiateDateF1}</div>
          )
        }
        {
          tdsF1 && (
            <div>
              TDS: {tdsF1}
              {
                fee.dueDateF1 && `(Due Date: ${fee.dueDateF1})`}
              {' '}
              {
                fee.initiateDateF1 &&
                <Link onClick={onUploadTDSClick} to='#'>Upload </Link>
              }
              /
              {
                (tdsChallanUploaded) &&
                <Link onClick={onDownloadClick} to='#'>Download</Link>
              }
            </div>
          )
        }
        {
          loan.termSheet.processingFeeFromLoan && context.permissions.includes('su_manage') &&
          <span className='g_muted'>Processing fee to be collected from disbursed amount after disbursement</span>

        }
      </div>
      <div className='g_flex_v'>
        <span className='g_flex_h g_flex_right'>
          <BadgeUI label={status || 'unpaid'} />
          {
            !fee.paidDateF1 && loan.status != 'disbursed' && loan.status != 'closed' &&
            <span className='icon icon-pencil g_link_2 g_m_left_50' onClick={onUpdateClick} />
          }
        </span>
        {

          !fee.paidDateF1 && fee.status !== 'paid' &&
          status !== 'waived' &&
          context.permissions.includes('su_superuser_business') &&
          <>
            <Link onClick={onUploadTDSClick} to='#'>Upload TDS Challan {part}</Link>
            <div className='g_m_top_50'>
              <Link onClick={onDownloadClick} to='#'>Download TDS Challan {part}</Link>
            </div>
            <span className='g_flex_h g_flex_right'>
              {
                context.permissions.includes('su_finance') &&
                <ButtonTinyUI label='Collect Processing Fee'
                  onClick={onProcFeeClick} className='g_m_top_50'
                  rowId={part}
                />
              }
            </span>
          </>
        }
        {/*<span>{fee.paidDateF1}</span>*/}
      </div>
    </div>

    <ProcFeeConfirmationModalSF
      context={context} loan={loan}
      onRefreshClick={onRefreshClick} onProcFeeCancel={onProcFeeCancel}
      procFeeMode={procFeeMode} selectedPart={selectedPart} feeAmount={feeAmount}
    />
  </CardUI>

export default ProcessingFeeUI
